import NewsDetailsPage from "./news-details.page"

export default NewsDetailsPage;
